import ButtonsContainer from "../general/ButtonsContainer";
import { ExternalLink } from "../ExternalLink";
import { defineMessages, FormattedMessage } from "react-intl";
import React, { useContext } from "react";
import { InstallContext, Steps } from "./InstallContext";


const messages = defineMessages( {
	skip: {
		id: "install.skip",
		defaultMessage: "Skip installation and go to MyYoast",
	},
} );

export const SkipInstallationFlowLink = () => {
	const { steps } = useContext( InstallContext );

	const isBrandInsightsStep = steps.current.id === Steps.BRAND_INSIGHTS.id;

	return isBrandInsightsStep
		? null
		: <ButtonsContainer>
			<ExternalLink href={ "/" }><FormattedMessage { ...messages.skip } /></ExternalLink>
		</ButtonsContainer>;
};
